import CheckIcon from '../../assets/icons/check_bg_green.svg'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { stepReset } from '../../redux/steps'
import {
  Container,
  SuccessWrapper,
  SuccesImageWrapper,
  SuccessImage,
  SuccessTitle,
  ContinueSubtitle,
  ButtonsWrapper,
  Button
} from './styles'

export function PatientSuccess ({ onNewPatient }) {
  const history = useHistory()
  const dispatch = useDispatch()

  const handleGoHome = () => {
    // Reset steps state when going home
    dispatch(stepReset())
    history.push('/home')
  }

  const handleNewPatient = () => {
    dispatch(stepReset())
    if (onNewPatient) onNewPatient()
  }

  return (
    <Container>
      <SuccessWrapper>
        <SuccesImageWrapper>
          <SuccessImage width='57' height='57' src={CheckIcon} alt='success' />
        </SuccesImageWrapper>

        <SuccessTitle> Datos cargados con éxito! </SuccessTitle>

        <ContinueSubtitle> Paciente registrado correctamente </ContinueSubtitle>

        <ButtonsWrapper>
          <Button onClick={handleGoHome}> Volver al inicio </Button>
          <Button highlighted onClick={handleNewPatient}> Cargar otro paciente </Button>
        </ButtonsWrapper>
      </SuccessWrapper>
    </Container>
  )
}

export default PatientSuccess
